import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import AsyncSelect from "react-select/async";
import {useThemeMode, systemMode} from "../../_metronic/partials/layout/theme-mode/ThemeModeProvider";

export function AGCStaticSelect({
                                    data,
                                    formik,
                                    isMulti,
                                    name,
                                    toolTip = "",
                                    value,
                                    id,
                                    forUpdate = false,
                                    required = true,
                                    includeAllOption = true,
                                    onChange
                                }) {
    const [dataList, setDataList] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const {mode} = useThemeMode();

    // Determine if dark mode is active
    const isDarkMode = mode === 'dark' || (mode === 'system' && systemMode === 'dark');

    if (toolTip === "") {
        toolTip = "Select " + name;
    }

    if (value === null) {
        value = ""
    }

    const handleChange = (option) => {
        if (onChange) {
            onChange(option);
        } else if (formik && id) {
            formik.setFieldValue(id, option);
        }
    };

    // Custom styles for dark theme
    const customStyles = isDarkMode ? {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#1e1e2d',
            borderColor: state.isFocused ? '#009ef7' : '#2b2b40',
            color: '#a1a5b7',
            '&:hover': {
                borderColor: '#009ef7'
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#1e1e2d',
            border: '1px solid #2b2b40'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#2b2b40' : '#1e1e2d',
            color: '#a1a5b7',
            '&:hover': {
                backgroundColor: '#2b2b40'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        input: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6c7293'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#2b2b40'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#a1a5b7',
            '&:hover': {
                backgroundColor: '#3b3b54',
                color: '#ffffff'
            }
        })
    } : {};

    useEffect(() => {
        if (data && data.length > 0) {
            // Check if "All" option already exists to avoid duplicates if data updates
            const hasAllOption = data.some(item => item.id === "" || item.id === null);

            if (includeAllOption && !hasAllOption) {
                setDataList([{id: "", name: "All " + name}, ...data]);
            } else {
                setDataList(data);
            }
        } else {
            setDataList([]);
        }
    }, [data, name, includeAllOption]);

    const loadOptions = (inputValue, callback) => {
        const filteredOptions = dataList.filter((option) =>
            option.name.toLowerCase().includes(inputValue.toLowerCase())
        );

        callback(filteredOptions);
    };

    return (
        <>
            <Form.Label className={required ? "required" : ""}>{name}</Form.Label>
            <AsyncSelect
                isMulti={isMulti}
                defaultOptions={dataList}
                value={value}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                inputValue={inputValue}
                onInputChange={setInputValue}
                loadOptions={loadOptions}
                isDisabled={forUpdate}
                onChange={handleChange}
                styles={customStyles}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
